import './CoralProductSellingPoints.scss'

import { Asset } from '@websrc/App/Components/Asset/Asset'
import { mapCoralWebProductSellingPoints } from '@websrc/DataMappers/mapSpot'
import clsx from 'clsx'
import React, { FC } from 'react'

// Type definition
type CoralProductSellingPointsProps = ReturnType<typeof mapCoralWebProductSellingPoints>

// Functional component for Product Selling Points
export const CoralProductSellingPoints: FC<CoralProductSellingPointsProps> = ({
  product_selling_points,
}) => {
  // Helper function to check if a number is odd
  const isUneven = (num: number) => num % 2 !== 0

  return (
    <div className={'psp'}>
      <div className={'psp__list'}>
        {/* Iterate over product selling points and render each item */}
        {product_selling_points.map((item, index) => (
          <div
            className={clsx('psp__list-item', isUneven(index) ? 'm--right' : 'm--left')}
            key={item.headline}
          >
            <div className={'psp__list-item__info'}>
              <h2 className={'psp__list-item__header'}>{item.headline}</h2>
              <p className={'psp__list-item__description'}>{item.description}</p>
            </div>
            {item.image && (
              <div className={'psp__list-item__image-container'}>
                <Asset
                  className={'psp__list-item__image'}
                  objectFit={'cover'}
                  thumbnail={item.image}
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
